import { getApi, postApi } from "../apiCall";

const BASE_URL = `${process.env.REACT_APP_API_URL}/banking/insights/banking_otc`;

// --------- Upload & Extract ---------

export const extractPdf = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const url = `${BASE_URL}/extract-pdf`;
  return postApi(url, formData);
};

export const getExtractPdfStatus = (taskId) => {
  const url = `${BASE_URL}/extract-pdf/status/${taskId}`;
  return getApi(url);
};

// --------- Contracts ---------

export const createContract = (data = {}) => {
  const url = `${BASE_URL}/contracts`;
  return postApi(url, data);
};

export const getActiveContracts = () => {
  const url = `${BASE_URL}/contracts/active`;
  return getApi(url);
};

export const getInactiveContracts = () => {
  const url = `${BASE_URL}/contracts/inactive`;
  return getApi(url);
};

export const getContractById = (id) => {
  const url = `${BASE_URL}/contracts/${id}`;
  return getApi(url);
};

export const updateContract = (id, data = {}) => {
  const url = `${BASE_URL}/contracts/${id}`;
  return postApi(url, data);
};

export const getContractPdf = (id) => {
  const url = `${BASE_URL}/contracts/${id}/pdf`;
  return getApi(url, {}, false, "blob");
};

// --------- Analytics ---------

export const getContractAnalytics = (id, groupBy) => {
  const url = groupBy
    ? `${BASE_URL}/contracts/${id}/analytics?group_by=${groupBy}`
    : `${BASE_URL}/contracts/${id}/analytics`;
  return getApi(url);
};

export const getContractReturnAnalytics = (id, groupBy) => {
  const url = groupBy
    ? `${BASE_URL}/contracts/${id}/return-analytics?group_by=${groupBy}`
    : `${BASE_URL}/contracts/${id}/return-analytics`;
  return getApi(url);
};

// --------- Cumulative ---------

export const getCumulativeOverview = () => {
  const url = `${BASE_URL}/cumulative/overview`;
  return getApi(url);
};

export const getCumulativeSupply = (groupBy) => {
  const url = groupBy
    ? `${BASE_URL}/cumulative/supply?group_by=${groupBy}`
    : `${BASE_URL}/cumulative/supply`;
  return getApi(url);
};

export const getCumulativeReturn = (groupBy) => {
  const url = groupBy
    ? `${BASE_URL}/cumulative/return?group_by=${groupBy}`
    : `${BASE_URL}/cumulative/return`;
  return getApi(url);
};

export const getCumulativeSupplySources = () => {
  const url = `${BASE_URL}/cumulative/supply-sources`;
  return getApi(url);
};

export const getCumulativeSupplyDestinations = () => {
  const url = `${BASE_URL}/cumulative/supply-destinations`;
  return getApi(url);
};

// --------- Reference ---------

export const getTraders = () => {
  const url = `${BASE_URL}/traders`;
  return getApi(url);
};

// --------- Internal ---------

export const insertGnaTgnaIsgs = (data = {}) => {
  const url = `${BASE_URL}/insert-gna-tgna-isgs`;
  return postApi(url, data);
};
